export const getWaterfallAnalysesData = state => state.waterfallAnalyses.all;
export const getWaterfallAnalysisData = state => state.waterfallAnalyses.waterfallAnalysis;
export const waterfallAnalysesIsFetching = state => state.waterfallAnalyses.loading.all;
export const waterfallAnalysisIsFetching = state => state.waterfallAnalyses.loading.waterfallAnalysis;